<div class="row">
  <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-4">
    <div class="mb-3">
      <label class="form-label" for="primerNombre">Primer nombre</label>
      <div class="form-control">{{ beneficiario.PrimerNombre }}</div>
    </div>
  </div>
  <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-4">
    <div class="mb-3">
      <label class="form-label" for="segundoNombre">Segundo nombre</label>
      <div class="form-control">{{ beneficiario.SegundoNombre }}</div>
    </div>
  </div>
  <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-4">
    <div class="mb-3">
      <label class="form-label" for="primerApellido">Primer apellido</label>
      <div class="form-control">{{ beneficiario.PrimerApellido }}</div>
    </div>
  </div>
  <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-4">
    <div class="mb-3">
      <label class="form-label" for="segundoApellido">Segundo apellido</label>
      <div class="form-control">{{ beneficiario.SegundoApellido }}</div>
    </div>
  </div>
  <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
    <div class="mb-3">
      <label class="form-label" for="tipoDoc">Tipo documento</label>
      <div class="form-control">
        {{ beneficiario.TipoDeDocumentoDeIdentidad }}
      </div>
    </div>
  </div>
  @if (beneficiario.pais != null) {
    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-4">
      <div class="mb-3">
        <label class="form-label" for="pais">País de origen</label>
        <div class="form-control">{{ beneficiario.pais }}</div>
      </div>
    </div>
  }
  <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
    <div class="mb-3">
      <label class="form-label" for="NumeroDeDocumento">Número documento</label>
      <div class="form-control">{{ beneficiario.NumeroDeDocumento }}</div>
    </div>
  </div>
  <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
    <div class="mb-3">
      <label class="form-label" for="genero">Género</label>
      <div class="form-control">
        {{ !beneficiario.Genero ? '' : beneficiario.Genero }}
      </div>
    </div>
  </div>

  @if (!esIntermediario || existePropuesta==true) {
    <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3"
      >
      <div class="mb-3">
        <label class="form-label" for="numCelular">Número de celular 1</label>
        <div class="form-control">{{ beneficiario.numeroTelefono }}</div>
      </div>
    </div>
  }
  @if (!esIntermediario || existePropuesta==true) {
    <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3"
      >
      <div class="mb-3">
        <label class="form-label" for="numCelular2">Número de celular 2</label>
        <div class="form-control">{{ beneficiario.numeroOpcional }}</div>
      </div>
    </div>
  }
  <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
    <div class="mb-3">
      <label class="form-label" for="fechaNacimiento">Fecha de nacimiento</label>
      <div class="form-control">
        {{ beneficiario.FechaDeNacimiento | date: 'dd/MM/yyyy' : 'UTC' }}
      </div>
    </div>
  </div>
  <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
    <div class="mb-3">
      <label class="form-label" for="fechaexpedicion">Fecha expedición</label>
      <div class="form-control">
        {{ beneficiario.FechaDeExpedicionDelDocumento | date: 'dd/MM/yyyy' : 'UTC' }}
      </div>
    </div>
  </div>
  <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
    <div class="mb-3">
      <label class="form-label" for="estado">Estado civil</label>
      <div class="form-control">{{ beneficiario.EstadoCivil }}</div>
    </div>
  </div>
  <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
    <div class="mb-3">
      <label class="form-label" for="credito">Acceso a crédito formal con anterioridad</label>
      <div class="form-control">
        {{ beneficiario.HaTenidoCredito }}
      </div>
    </div>
  </div>
  @if (beneficiario.fechaCreditoAnterior!=undefined
    && beneficiario.fechaCreditoAnterior!='') {
    <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
      <div class="mb-3">
        <label class="form-label" for="creditoAnterioridad">Fecha crédito formal con anterioridad</label>
        <div class="form-control">
          {{ beneficiario.fechaCreditoAnterior | date: 'dd/MM/yyyy' : 'UTC'}}
        </div>
      </div>
    </div>
  }
  <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
    <div class="mb-3">
      <label class="form-label" for="fechaMatricula">Fecha de matrícula en cámara de comercio o creación de tu negocio</label>
      <div class="form-control">
        {{ beneficiario.fechaRegistroActividadEconomica | date: 'dd/MM/yyyy' : 'UTC' }}
      </div>
    </div>
  </div>
  <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
    <div class="mb-3">
      <label class="form-label" for="NivelDeEstudios">Nivel de estudios</label>
      <div class="form-control">{{ beneficiario.NivelDeEstudios }}</div>
    </div>
  </div>
  <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
    <div class="mb-3">
      <label class="form-label" for="seguridadSocial">Paga seguridad social</label>
      <div class="form-control">{{ beneficiario.PagaSeguridadSocial }}</div>
    </div>
  </div>
  <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
    <div class="mb-3">
      <label class="form-label" for="tipoVivienda">Tipo de vivienda</label>
      <div class="form-control">{{ beneficiario.TipoDeVivienda }}</div>
    </div>
  </div>
  <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
    <div class="mb-3">
      <label class="form-label" for="personasACargo">Personas a cargo</label>
      <div class="form-control">{{ beneficiario.personasACargo }}</div>
    </div>
  </div>
  <div class="col-12 col-sm-3 col-md-3 col-lg-4 col-xs-4">
    <div class="mb-3">
      <label class="form-label" for="departamentoResidencia">Departamento de residencia</label>
      <div class="form-control">
        {{ beneficiario.DepartamentoResidencia[0]?.nombreDepartamento }}
      </div>
    </div>
  </div>
  <div class="col-12 col-sm-3 col-md-3 col-lg-4 col-xs-4">
    <div class="mb-3">
      <label class="form-label" for="ciudadResidencia">Ciudad de residencia</label>
      <div class="form-control">
        {{ beneficiario.CiudadResidencia[0]?.nombreCiudad }}
      </div>
    </div>
  </div>
  <div class="col-12 col-sm-3 col-md-3 col-lg-4 col-xs-3">
    <div class="mb-3">
      <label class="form-label" for="tipoCiudad">Tipo de ciudad</label>
      <div class="form-control">
        {{ beneficiario.CiudadRuralidad }}
      </div>
    </div>
  </div>
  @if (beneficiario.idLocalidad != null && beneficiario.idLocalidad != '') {
    <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
      <div class="mb-3">
        <label class="form-label" for="localidad">Localidad</label>
        <div class="form-control">
          {{ getNombreLocalidad(beneficiario.idLocalidad) }}
        </div>
      </div>
    </div>
  }
  <div class="col-12 col-sm-4 col-md-4 col-lg-6 col-xs-4">
    <div class="mb-3">
      <label class="form-label" for="barrio">Barrio del establecimiento</label>
      <div class="form-control">{{ beneficiario.BarrioDeResidencia }}</div>
    </div>
  </div>
  <div class="col-12 col-sm-4 col-md-4 col-lg-6 col-xs-4">
    <div class="mb-3">
      <label class="form-label" for="direccion">Dirección del establecimiento</label>
      <div class="form-control">{{ beneficiario.DireccionDeResidencia }}</div>
    </div>
  </div>
  @if (!esIntermediario || existePropuesta==true) {
    <div class="col-12 col-sm-10 col-md-10 col-lg-6 col-xs-12"
      >
      <div class="mb-3">
        <label class="form-label" for="correo">Correo electrónico</label>
        <div class="form-control">{{ beneficiario.correoElectronico }}</div>
      </div>
    </div>
  }
  <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
    <div class="mb-3">
      <label class="form-label" for="anio">Año de ventas</label>
      <div class="form-control">{{ beneficiario.AnioDeVentas }}</div>
    </div>
  </div>
  <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
    <div class="mb-3">
      <label class="form-label" for="nivelVentas">Nivel de ventas anuales</label>
      <div class="form-control">
        {{ beneficiario.NivelDeVentas | pesosCop }}
      </div>
    </div>
  </div>
  <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
    <div class="mb-3">
      <label class="form-label" for="activosAnuales">Año de activos anuales</label>
      <div class="form-control">{{ beneficiario.AnioDeActivos }}</div>
    </div>
  </div>
  <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
    <div class="mb-3">
      <label class="form-label" for="nivelActivos">Nivel de activos</label>
      <div class="detalle-field-hint-row">
        <div class="form-control" id="nivelActivos">
          {{ beneficiario.NivelDeActivos | pesosCop }}
        </div>
        <button
          type="button"
          class="detalle-field-hint"
          [attr.aria-label]="hintActivos"
          [attr.aria-describedby]="'tooltip-nivel-activos'"
          [attr.aria-expanded]="activosHintOpen"
          (mouseenter)="showActivosHint($event)"
          (mouseleave)="hideActivosHint()"
          (focus)="showActivosHint($event)"
          (blur)="hideActivosHint()"
        >
          <i class="fas fa-question detalle-field-hint__mark" aria-hidden="true"></i>
          <span
            id="tooltip-nivel-activos"
            class="detalle-field-hint__tooltip"
            [class.detalle-field-hint__tooltip--open]="activosHintOpen"
            [style.top]="activosHintStyle['top']"
            [style.left]="activosHintStyle['left']"
            role="tooltip"
          >
            {{ hintActivos }}
          </span>
        </button>
      </div>
    </div>
  </div>
  <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
    <div class="mb-3">
      <label class="form-label" for="rut">Tiene RUT</label>
      <div class="form-control">{{ beneficiario.tieneRUT?beneficiario.tieneRUT:'' }}</div>
    </div>
  </div>
  <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
    <div class="mb-3">
      <label class="form-label" for="minoria">Pertenece a una minoría</label>
      <div class="form-control">{{ beneficiario.minoria==1?'Si':'No' }}</div>
    </div>
  </div>
  @if (beneficiario.minoria==1) {
    <div class="col-12 col-sm-3 col-md-3 col-lg-4 col-xs-4">
      <div class="mb-3">
        <label class="form-label" for="descripcionMinoria">Descripción de minoría</label>
        <div class="form-control">{{ beneficiario.minoriaDescripcion }}</div>
      </div>
    </div>
  }
  <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
    <div class="mb-3">
      <label class="form-label" for="sisben">Sisbén</label>
      <div class="form-control">{{ beneficiario.sisben!=null? beneficiario.sisben ==true?'Si':'No': '' }}</div>
    </div>
  </div>
  @if (beneficiario.sisben) {
    <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3">
      <div class="mb-3">
        <label class="form-label" for="grupoSisben">Grupo de Sisbén</label>
        <div class="form-control">{{ beneficiario.grupoSisben }}</div>
      </div>
    </div>
  }
  <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
    <div class="mb-3">
      <label class="form-label" for="nombreFuente">¿Cómo te enteraste de neocrédito?</label>
      <div class="form-control">{{ beneficiario.nombreFuente }}</div>
    </div>
  </div>
  @if (!esIntermediario && beneficiario.idFuenteNeocredito == 7) {
    <div class="col-12 col-sm-3 col-md-6 col-lg-4 col-xs-2"
      >
      <div class="mb-3" >
        <label class="form-label" for="referido">Nombre referido</label>
        <div class="form-control">{{ beneficiario.nombreReferido }}</div>
      </div>
    </div>
  }
  @if (!esIntermediario && beneficiario.idFuenteNeocredito == 7) {
    <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xs-3"
      >
      <div class="mb-3">
        <label class="form-label" for="codigoReferido">Código del referido</label>
        <div class="form-control">{{ beneficiario.codigoReferido }}</div>
      </div>
    </div>
  }
  @if (!esIntermediario && beneficiario.idFuenteNeocredito == 8) {
    <div class="col-12 col-sm-3 col-md-6 col-lg-4 col-xs-2"
      >
      <div class="mb-3">
        <label class="form-label" for="cual">Cuál</label>
        <div class="form-control">{{ beneficiario.otraFuente }}</div>
      </div>
    </div>
  }
  @if (beneficiario.tiposContacto != null) {
    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-12">
      <div class="mb-3">
        <label class="form-label" for="contacto">¿Como deseas ser contactado?</label>
        <div class="form-control" style="height: 60px;">{{ beneficiario.tiposContacto }}</div>
      </div>
    </div>
  }
  <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-12">
    <div class="mb-3">
      <label for="camaraComercioVigente" class="form-label">¿Tiene Cámara de Comercio Vigente?</label>
      <div class="form-control">{{ beneficiario.camaraComercioVigente == null ? 'N.A.' :
      beneficiario.camaraComercioVigente == 1 ? 'Si' : 'No'}}</div>
    </div>
  </div>
  @if (esVistaMicroempresario) {
    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-12">
      <div class="mb-3">
        <label class="form-label" for="nombreNegocio">Nombre del negocio</label>
        <div class="form-control">{{ beneficiario.razonSocial }}</div>
      </div>
    </div>
  }
  <div class="col-12 col-sm-10 col-md-10 col-lg-12 col-xs-10">
    <div class="mb-3">
      <label class="form-label" for="actividadEconomica">Actividad económica</label>
      <div class="form-control" style="height: 60px;">{{ beneficiario.actividadEconomica }}</div>
    </div>
  </div>
</div>
